// Kotton Kahani — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Keep search accessible from the header instead of sending customers to a bare search page.
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchInput = document.querySelector('#site-search-input');
  const searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchPanel) {
    function closeSearch() {
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }

    function openSearch() {
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        if (searchInput) searchInput.focus();
      });
    }

    searchToggle.addEventListener('click', () => {
      if (searchPanel.hidden) {
        openSearch();
      } else {
        closeSearch();
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !searchPanel.hidden) {
        closeSearch();
        searchToggle.focus();
      }
    });

    document.addEventListener('click', event => {
      if (!searchPanel.hidden && !searchPanel.contains(event.target) && !searchToggle.contains(event.target)) {
        closeSearch();
      }
    });
  }

  // ── Cart count update ──────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badges = document.querySelectorAll('.cart-count');
        badges.forEach(b => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ── Product page thumbnail switcher ───────────────────────
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mediaItems = document.querySelectorAll('.product-page__media-item');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mediaId = this.dataset.mediaId;

      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      mediaItems.forEach(item => {
        const isActive = item.dataset.mediaId === mediaId;
        item.classList.toggle('active', isActive);

        if (!isActive) {
          item.querySelectorAll('video').forEach(video => video.pause());
        }
      });
    });
  });

  // ── Product image zoom ────────────────────────────────────
  const zoomModal = document.querySelector('[data-product-zoom]');
  if (zoomModal) {
    const zoomImage = zoomModal.querySelector('[data-zoom-image]');
    const zoomCloseButtons = zoomModal.querySelectorAll('[data-zoom-close]');
    const zoomPrev = zoomModal.querySelector('[data-zoom-prev]');
    const zoomNext = zoomModal.querySelector('[data-zoom-next]');
    const zoomIn = zoomModal.querySelector('[data-zoom-in]');
    const zoomOut = zoomModal.querySelector('[data-zoom-out]');
    const zoomTriggers = document.querySelectorAll('[data-zoom-open]');
    const zoomableItems = Array.from(document.querySelectorAll('.product-page__media-item[data-zoom-src]'));
    let activeZoomIndex = 0;
    let zoomScale = 1;

    function applyZoomScale() {
      if (!zoomImage) return;
      zoomImage.style.transform = `scale(${zoomScale})`;
      zoomImage.style.cursor = zoomScale > 1 ? 'zoom-out' : 'default';
    }

    function getActiveZoomIndex() {
      const activeItem = document.querySelector('.product-page__media-item.active[data-zoom-src]');
      const index = zoomableItems.indexOf(activeItem);
      return index >= 0 ? index : 0;
    }

    function showZoomImage(index) {
      if (!zoomableItems.length || !zoomImage) return;
      activeZoomIndex = (index + zoomableItems.length) % zoomableItems.length;
      const item = zoomableItems[activeZoomIndex];
      zoomImage.src = item.dataset.zoomSrc;
      zoomImage.alt = item.dataset.zoomAlt || '';
      zoomScale = 1;
      applyZoomScale();
    }

    function openZoom(index) {
      if (!zoomableItems.length) return;
      showZoomImage(index);
      zoomModal.classList.add('is-open');
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-zoom-open');
      if (zoomCloseButtons[0]) zoomCloseButtons[0].focus();
    }

    function closeZoom() {
      zoomModal.classList.remove('is-open');
      zoomModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-zoom-open');
      if (zoomImage) zoomImage.removeAttribute('src');
      zoomScale = 1;
      applyZoomScale();
    }

    zoomTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => openZoom(getActiveZoomIndex()));
    });

    zoomCloseButtons.forEach(button => {
      button.addEventListener('click', closeZoom);
    });

    if (zoomPrev) {
      zoomPrev.addEventListener('click', event => {
        event.stopPropagation();
        showZoomImage(activeZoomIndex - 1);
      });
    }

    if (zoomNext) {
      zoomNext.addEventListener('click', event => {
        event.stopPropagation();
        showZoomImage(activeZoomIndex + 1);
      });
    }

    if (zoomIn) {
      zoomIn.addEventListener('click', event => {
        event.stopPropagation();
        zoomScale = Math.min(zoomScale + 0.25, 3);
        applyZoomScale();
      });
    }

    if (zoomOut) {
      zoomOut.addEventListener('click', event => {
        event.stopPropagation();
        zoomScale = Math.max(zoomScale - 0.25, 1);
        applyZoomScale();
      });
    }

    document.addEventListener('keydown', event => {
      if (!zoomModal.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeZoom();
      } else if (event.key === 'ArrowLeft') {
        showZoomImage(activeZoomIndex - 1);
      } else if (event.key === 'ArrowRight') {
        showZoomImage(activeZoomIndex + 1);
      } else if (event.key === '+' || event.key === '=') {
        zoomScale = Math.min(zoomScale + 0.25, 3);
        applyZoomScale();
      } else if (event.key === '-' || event.key === '_') {
        zoomScale = Math.max(zoomScale - 0.25, 1);
        applyZoomScale();
      }
    });
  }

  // ── Sticky header shadow on scroll ────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 20px rgba(30,19,24,0.08)'
        : 'none';
    });
  }

  // ── Add to cart (AJAX) ─────────────────────────────────────
  const addForm = document.querySelector('.product-page__form');
  if (addForm) {
    const goToCartBtn = document.querySelector('[data-go-to-cart]');

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const productId = Number(addForm.dataset.productId);
        const productAlreadyInCart = cart.items.some(item => item.product_id === productId);

        if (productAlreadyInCart && goToCartBtn) {
          goToCartBtn.classList.remove('is-hidden');
        }
      })
      .catch(() => {});

    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('.product-page__add-btn');
      const variantId = this.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then(() => {
          btn.textContent = 'Added ✓';
          if (goToCartBtn) {
            goToCartBtn.classList.remove('is-hidden');
          }
          updateCartCount();
          setTimeout(() => {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          btn.textContent = 'Try Again';
          btn.disabled = false;
        });
    });
  }

  // ── Marquee pause on hover ─────────────────────────────────
  const marqueeInner = document.querySelector('.marquee-inner');
  if (marqueeInner) {
    const bar = marqueeInner.closest('.marquee-bar');
    if (bar) {
      bar.addEventListener('mouseenter', () => marqueeInner.style.animationPlayState = 'paused');
      bar.addEventListener('mouseleave', () => marqueeInner.style.animationPlayState = 'running');
    }
  }

});
